import React from "react";

import "./homestyle.css";
import SideBar1 from "../chats/sidebar1";
import HomeHeader1 from "../../components/HomeHeader1";
import ContentInner1 from "./ContentInner1";
import ContentInner2 from "./ContentInner2";
import { useChatContext } from "../../context/ChatContext";

const Homescsbc: React.FC = () => {
  
  const { initialStart } = useChatContext();

  // Toggle Sidebar Function
  // const toggleSidebar = (forceOpen?: boolean) => {
  //   let sidebar = document.getElementById("sidebar");
  //   let content = document.getElementById("content");
  //   let header = document.getElementById("header");

  //   if (forceOpen) {
  //     sidebar?.classList.add("open");  // ✅ Force Open Sidebar
  //     content?.classList.add("shrink");
  //     header?.classList.add("shrink");
  //   } else {
  //     sidebar?.classList.toggle("open");
  //     content?.classList.toggle("shrink");
  //     header?.classList.toggle("shrink");
  //   }
  // };


  return (
    <>
     <div className="sidebar-content-other">
      <SideBar1/>

        <div className="home-page-content-inner">
        <HomeHeader1/>

        {initialStart?
      <ContentInner2/>
      :
      <ContentInner1/>
      }

         
     {/* <ContentInner1/> */}
 {/* <ContentInner2/> */}
        </div>
      </div>
  
    </>
  );
};

export default Homescsbc;
